import { Configuration as BaseConfig } from '../../shared/configuration/shared.config';

export let Configuration = {

    adminApiUrl: BaseConfig.adminApiUrl,
    apiUrl: BaseConfig.apiUrl,
    metaDataURL: BaseConfig.metaDataURL,
    dashboardURL: BaseConfig.dashboardURL,

    urls: {
        industry: {
            get: 'api/v1/industry',
            add: 'api/v1/industry',
            edit: 'api/v1/industry',
            delete: 'api/v1/industry',
        },
        service: {
          get: 'api/v1/service',
        },

        vendor: {
            get: 'api/v1/vendor/admin/all',
            add: 'api/v1/vendor/admin',
            edit: 'api/v1/vendor/admin',
            delete: 'api/v1/vendor/admin',
            approve: 'api/v1/vendor/admin/approve',
            disapprove: 'api/v1/vendor/admin/disapprove',
        },

        inAppNotification: {
            get: 'api/v1/notification/inapp/template',
            add: 'api/v1/notification/inapp/template',
            edit: 'api/v1/notification/inapp/template',
            delete: 'api/v1/notification/inapp/template',
        },

        emailTemplateNotification: {
            get: 'api/v1/notification/email/template',
            add: 'api/v1/notification/email/template',
            edit: 'api/v1/notification/email/template',
            delete: 'api/v1/notification/email/template',
        },

        emailSettingsNotification: {
            get: 'api/v1/notification/email/settings',
            add: 'api/v1/notification/email/settings',
            edit: 'api/v1/notification/email/settings',
            delete: 'api/v1/notification/email/settings',
        },

        review_settings: {
            get: 'api/v1/project/admin/review/settings',
            edit: 'api/v1/project/admin/review/settings',
        },
        meta_data: {
            get: 'metadata'
        },
        featuredPartners: {
            put: 'api/v1/search/admin/featured/config',
            get: 'api/v1/search/admin/featured/config',
        },
        changeCompanyNameRequest: {
          customerGet: 'api/v1/customer/admin/name/change',
          partnerGet: 'api/v1/partner/admin/name/change',
          customerApprove: 'api/v1/customer/admin/name/change/',
          partnerApprove: 'api/v1/partner/admin/name/change/',
        },
        customerProjectQuotaRequest: {
          get: 'api/v1/customer/admin/quota/increment',
          put: 'api/v1/customer/admin/quota/increment',
        },
        currency: {
            get: 'api/v1/offer/config/exchange',
            put: 'api/v1/offer/admin/config/exchange'
        },
        unlocks: {
            get: 'api/v1/project/setting/unlocks',
            put: 'api/v1/project/admin/setting/unlocks'
        },
        activityType: {
            get: 'api/v1/admin/activity/types',
            edit: 'api/v1/admin/activity/types',
            add: 'api/v1/admin/activity/types',
            delete: 'api/v1/admin/activity/types/remove',
        },
        activityRecord: {
          add: (type, id) => `api/v1/admin/${type}/${id}/activity/records`,
          partnerProjects: (partnerId) => `api/v1/project/admin/activity/partner/${partnerId}`,
          userCustomerProjects: (customerId, userId) => `api/v1/project/admin/activity/customer/${customerId}/user/${userId}`,
          getActivityLogFor: (type, targetId) => `api/v1/admin/${type}/${targetId}/activity/records`,
          getActivityRecords: 'api/v1/admin/activity/records',
          delete: `api/v1/admin/activity/records`,
          update: `api/v1/admin/activity/records`,
          markAsDone: id => `api/v1/admin/activity/records/${id}/mark-as-done`,
        },
        getAdminName: 'api/v1/admin/list/names',
        user: {
          get: 'api/v1/user'
        }
    }

};
